import { useEffect, useRef, useState } from "react"
import cn from "classnames"
import richText from "utilities/richText"

export default function InlineAccordion({ blok }) {
  const [expanded, setExpanded] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    if (!ref.current) return

    ref.current.style.height = expanded ? `${ref.current.scrollHeight + 32}px` : "0px"
  }, [expanded, ref])

  return (
    <div className="mx-auto max-w-full bg-blue-light mb-4 last:mb-0 overflow-hidden">
      <div
        className={cn(
          "flex flex-row justify-between transition-all duration-300 prose-h3:pb-0 prose-h3:font-primary prose-h3:font-normal",
          {
            "bg-purple": expanded,
            "bg-blue-light": !expanded,
          }
        )}
      >
        <h3
          className={cn(
            "text-m1 lg:text-m2 px-4 lg:px-7 my-2 max-w-[75%] leading-8 break-words font-normal font-primary self-center",
            {
              "text-white": expanded,
              "text-purple": !expanded,
            }
          )}
          lang="en"
        >
          {blok.title}
        </h3>
        <button
          className={cn("faq-section-btn w-[72px] px-6 py-8 transition-all duration-300", {
            "bg-purple": !expanded,
            "bg-teal": expanded,
          })}
          aria-label="toggle accordion state"
          onClick={() => setExpanded(!expanded)}
        >
          <span
            className={cn("text-white text-m2 leading-8 transition-all duration-300", {
              "rotate-45 duration-300": expanded,
              "rotate-90 duration-300": !expanded,
            })}
          >
            {expanded ? "-" : "+"}
          </span>
        </button>
      </div>
      <div
        ref={ref}
        className={cn(
          "faq-section-content transition-all duration-300 px-7 lg:pr-24 prose-p:font-light prose-p:leading-8 origin-top",
          {
            "py-4": expanded,
          }
        )}
        inert={!expanded ? "" : null}
      >
        {richText(blok.content)}
      </div>
    </div>
  )
}
